import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SortingState } from './sorting.state';
import { SortingTriggerService } from './sorting-trigger.service';

@NgModule({
	declarations: [],
	imports: [CommonModule],
	providers: [SortingState, SortingTriggerService]
})
export class SortingModule {}
